/**
 * Returns a default value if none in args.
 * @param {Array} list
 */
export function def(value, _def) {
    return value || _def;
}

export default { def };
